module.exports = __webpack_public_path__ + "static/img/logo-valparaiso.f842ff2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-valparaiso.svg
// module id = 10
// module chunks = 0